import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;
`

export const Text = styled.span`
  margin-top: 40px;
  color: ${props => props.theme.color.white};
  font-size: 8px;
  font-family: "sharp_groteskmedium_20", Arial, Helvetica, sans-serif;
  text-transform: lowercase;
  letter-spacing: 12px;
  line-height: 2;
  text-align: center;
  z-index: 2;
`
